import { render, staticRenderFns } from "./ReporteCrediticio.vue?vue&type=template&id=05143bf9&scoped=true&lang=html&"
import script from "./ReporteCrediticio.vue?vue&type=script&lang=js&"
export * from "./ReporteCrediticio.vue?vue&type=script&lang=js&"
import style0 from "./ReporteCrediticio.vue?vue&type=style&index=0&id=05143bf9&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05143bf9",
  null
  
)

export default component.exports